
import img0 from './Images/ConfigureAgentTool.png';
import img1 from './Images/DataQuery.png';
import img2 from './Images/CreateAgent.png';
import img3 from './Images/CreateAgent2.png';
import img4 from './Images/PublishAgent.png';
import img5 from './Images/RunAgent.png';
  
const content = `# SecureAI Agent Automation
  
SecureAI offers agentic AI automation features out of the box and enables users to create AI agents for workflow automation. An agent can be easily created with a natural language 
prompt to automate any number of tasks. It can interact with various type of resources, such as files, databases, cloud storage, emails, and any kind of APIs, through the use of 
various agent tools, to process data and automate workflows.  
  
SecureAI provides a number of tools that can be configured to meet your automation needs. An administrative user may configure such tools and assign them, together with tool 
configurations, to specific user roles. Such roles can then be assigned to users and user groups. The users can create AI agents by selecting a pre-configured GenAI LLM, providing 
a detail agent prompt, and selecting the necessary tools and tool configurations for GenAI LLM to use. An agent can be tested, then published and scheduled to run automatically.  

## Agent Tool configurations
A user with the \`System Administrator\` role should configure all available agent tools and assign to various user roles. Below are the steps to configure the agent tools:  
1. Select \`Agent Tools under the \`Settings\` menu on the top right corner
2. For each agent tool that is needed for the organization, select \`Details\` to edit the agent tool configuration
3. Assign the agent tool to specific user roles. Only users with such roles can access this agent tool
4. Under the “Configurations” tab, click on “Add New” to add a new configuration

  ![Configure Agent Tool](${ img0 })  

5. Each agent tool may have different configuration entries to be completed. Click on \`Save\` to save the configuration
6. Assign the agent tool configuration to specific user roles. Only users with such roles can access this agent tool configuration
7. Repeat steps 2~6 above until all necessary configurations are added

Once the necessary agent tools are configured with necessary configurations, a user can start to create, configure, and run agents. Below are the steps:  
1. Select the \`Agent Automation\` feature from the \`Services\` menu

  ![Select Data Query Feature](${ img1 })  

2. Click on \`Create Agent\` to create a new AI agent with the following information

    ![Create Agent](${ img2 })  

- Name: {Name for this agent}  
- Description: {Description for this agent}  
- LLM: {Select a GenAI LLM configured by System Administrator}  
- Agent Prompt: {Enter a detailed prompt for this agent}  

    ![Create Agent Details](${ img3 })  

3. Click on the \`Save\` button to save your progress
4. Do not add any triggers yet
5. Click on the \`Select and add tool\` dropdown, choose a tool that is needed for this agent, such as the \`File Tool\`. Then select an agent tool configuration from the 
\`Configuration\` dropdown. Repeat this step until all necessary agent tools and associated configurations are selected  
6. From the top of the screen, click on the \`Save\` button to save this agent. Then you can select the \`Test Run\` button to run this agent. The details for running this agent 
will be displayed  
7. You can review the results after the process is completed. If any change is needed to the agent prompt or agent tool configuration, you may adjust as needed and test it again
8. After the agent is successfully tested, you may click on \`Save & Publish\` to publish this agent  

    ![Publish Agent](${ img4 })  

9. For a published agent, you can adjust the trigger as needed to schedule it to run periodically, or click on the \`Run Agent Manually\` button to run it manually
  
    ![Run Agent](${ img5 })  
  

Please note that SecureAI automatically enforces the data security policy configured for each GenAI LLM. If sensitive data should not be revealed to a GenAI LLM, SecureAI will used 
a proprietary solution to interact with GenAI LLM, so that GenAI LLM can perform data processing and automate workflows without accessing the actual sensitive data.  
  
When an agent generates outputs or performs certain tasks, the data access roles assigned to you will determine whether the sensitive data will be revealed to you or whether certain 
data operations (such as insert, update or delete) are allowed for such data. Please check with your system administrator if you need access to certain types of sensitive, 
confidential, or regulated data.  
  
  `
  
export default content;
